module.exports = __webpack_public_path__ + "static/7dbf82f9-2aab-445a-985d-89425616e0c8-769702c8b4adc276a34579b311cda3fa.jpeg";